module.exports = __webpack_public_path__ + "static/media/bundle_bg_B.dcbcaec8.png";